module.exports = __webpack_public_path__ + "media/person-recommendations.983e9f8c.webm";